exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-5d004131]{height:74%;left:0;position:absolute;top:0;width:100%}.wrapper.from-header[data-v-5d004131]{cursor:pointer}.wrapper.offset[data-v-5d004131]{margin-left:21px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d004131","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Grid/cells/checkboxProxy.vue
// module id = DQ02
// module chunks = 12